import { deleteEmployer } from '../../../../../TemporaryConmonents/AddProject/helpers/actions';
import { useContext } from 'react';
import { AddProjectContext } from '../../../../../TemporaryConmonents/AddProject/Context/AddProjectContext';

export const usePeopleCard = (employerId: number) => {
    const { setProjectsUsers, projectId, allProjectUsers, managers } =
        useContext(AddProjectContext);

    const projectUser = allProjectUsers.find((user) => user.id === employerId);

    const onDeleteEmployer = () => {
        deleteEmployer(projectId, employerId).then((data) => {
            setProjectsUsers(data.project_users);
        });
    };
    return { onDeleteEmployer, projectUser, managers };
};
